import clsx from 'clsx';
import React from 'react';

import './Zicon.css'

const ZIcon = ({ unicode, className, style, ...props }) => {
    return (
        <i
            className={clsx(`z-icon select-none ${className}`)}
            {...props}
            style={{
                fontFamily: 'Wasabi',
                '--unicode': `"\\${unicode.toUpperCase()}"`,
                ...style,
            }}
        />
    );
};

export default ZIcon;
